"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFingerprint = exports.getFingerprint = void 0;
var uuid_1 = require("./uuid");
var COOKIE_NAME = '_apms_sdk_fingerprint';
function getFingerprint() {
    if (typeof localStorage !== 'undefined') {
        var fingerprint_1 = localStorage.getItem(COOKIE_NAME);
        return fingerprint_1 ? fingerprint_1 : null;
    }
    var fingerprint = document.cookie
        .split('; ')
        .find(function (cookie) { return cookie.startsWith(COOKIE_NAME + '='); });
    if (fingerprint) {
        return fingerprint.split('=')[1];
    }
    return null;
}
exports.getFingerprint = getFingerprint;
function setFingerprint() {
    var existingFingerprint = getFingerprint();
    if (existingFingerprint) {
        console.log('[APMS] Fingerprint already exists:', existingFingerprint);
        return existingFingerprint;
    }
    var uuid = (0, uuid_1.uuidv4)();
    var fingerprint = "" + uuid;
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem(COOKIE_NAME, fingerprint);
        console.log('[APMS] Fingerprint set in local storage:', fingerprint);
    }
    else {
        document.cookie = COOKIE_NAME + "=" + fingerprint + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
        console.log('[APMS] Fingerprint set in cookie:', fingerprint);
    }
    return fingerprint;
}
exports.setFingerprint = setFingerprint;
